{
  "_comment": "[CI-LOCKED] Kandungan fail ini telah dikunci. Sumbangan dialu-alukan, tetapi pengesahan perubahan mungkin ditunda.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "Bot $1 berkata:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Ejen",
  "ACTIVITY_YOU_SAID_ALT": "Anda berkata:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot lampirkan:",
  "ACTIVITY_CODE_ALT": "Sampel kod: $1",
  "ACTIVITY_CONTENT_CAUTION": "Kandungan yang dijana AI mungkin salah",
  "ACTIVITY_CODE_CAUTION": "Kod dijana AI. Semak dan gunakan dengan berhati-hati",
  "ACTIVITY_ERROR_BOX_TITLE": "Mesej ralat",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Klik untuk berinteraksi.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Mesej adalah interaktif.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Satu atau beberapa pautan dalam mesej.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Penghantaran telah gagal.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Anda lampirkan:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 lampiran.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 lampiran.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 lampiran.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 lampiran.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 lampiran.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Gagal dihantar. [Cuba Semula][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Menghantar",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Dihantar pada $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Sebentar tadi",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Sejam yang lalu",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Seminit yang lalu",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Hari Ini",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Semalam",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Ralat penguraian Kad Mudah Suai",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Ralat pemaparan Kad Mudah Suai",
  "ATTACHMENT_AUDIO": "Klip audio.",
  "ATTACHMENT_CARD": "Kad: $1 $2 $3",
  "ATTACHMENT_FILE": "Fail: $1",
  "ATTACHMENT_IMAGE": "Imej",
  "ATTACHMENT_TEXT": "Teks: $1",
  "ATTACHMENT_VIDEO": "Klip video",
  "AVATAR_ALT": "$1 avatar",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Seterusnya",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Sebelumnya",
  "CITATION_MODEL_DIALOG_ALT": "Petikan",
  "CLOSE_BUTTON_ALT": "Tutup",
  "COLLAPSIBLE_GROUPING_TITLE": "Berfikir…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Perkara ini dipaparkan apabila bot sedang menyusun mesej respons dalam kumpulan jika tiada abstrak disediakan.",
  "COLLAPSE_BUTTON_LESS": "Tunjukkan kurang",
  "COLLAPSE_BUTTON_LESS.comment": "Ini ialah teks butang chevron untuk meruntuhkan kumpulan mesej. Apabila pengguna akhir mengklik butang tersebut, kumpulan mesej akan dilipat.",
  "COLLAPSE_BUTTON_MORE": "Tunjukkan lagi",
  "COLLAPSE_BUTTON_MORE.comment": "Ini ialah teks butang chevron untuk mengembangkan kumpulan mesej. Apabila anda akhir mengklik butang tersebut, kumpulan mesej akan berkembang.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Disambungkan",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Bersambung…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Tidak dapat bersambung.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Gangguan rangkaian telah berlaku. Bersambung semula…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Ralat telah berlaku. Sila semak konsol atau hubungi pembangun bot.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Masa yang lebih lama daripada biasa diambil untuk bersambung.",
  "CONNECTIVITY_STATUS_ALT": "Status Sambungan: $1",
  "COPY_BUTTON_TEXT": "Salin",
  "COPY_BUTTON_COPIED_TEXT": "Disalin",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Serah",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Batal",
  "FEEDBACK_FORM_PLACEHOLDER": "Berikan seberapa banyak butiran yang anda boleh, tetapi jangan masukkan apa-apa maklumat peribadi atau sensitif.",
  "FEEDBACK_FORM_TITLE": "Beritahu kami tentang pengalaman anda",
  "FILE_CONTENT_ALT": "'$1'",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Muat turun fail '$1'",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Muat turun fail '$1' dengan saiz $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "'$1' dengan saiz $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Buka dalam tetingkap yang baharu; luaran.",
  "RECEIPT_CARD_TAX": "Cukai",
  "RECEIPT_CARD_TOTAL": "Jumlah",
  "RECEIPT_CARD_VAT": "VAT",
  "REFERENCE_LIST_HEADER_ONE": "$1 rujukan",
  "REFERENCE_LIST_HEADER_FEW": "$1 rujukan",
  "REFERENCE_LIST_HEADER_MANY": "$1 rujukan",
  "REFERENCE_LIST_HEADER_OTHER": "$1 rujukan",
  "REFERENCE_LIST_HEADER_TWO": "$1 rujukan",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Padamkan lampiran $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Padamkan",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Fail",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Imej",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Tidak boleh menghantar mesej kosong.",
  "SPEECH_INPUT_LISTENING": "Mendengar…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon dimatikan",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon dihidupkan",
  "SPEECH_INPUT_STARTING": "Bermula…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Seterusnya",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Sebelumnya",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Tindakan dicadangkan",
  "TEXT_INPUT_ALT": "Kotak input mesej",
  "TEXT_INPUT_PLACEHOLDER": "Taip mesej anda",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Mula bercakap...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Sedang mendengar...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Memproses...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Bercakap untuk menyampuk...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Hantar",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Cakap",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Muat naik fail",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Pad kekunci telefon",
  "TEXT_INPUT_DROP_ZONE": "Jatuhkan fail",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Panjang mesej dilebihi",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Hanya menyokong input digit tunggal",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 lampiran",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 lampiran",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 lampiran",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 lampiran",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 lampiran",
  "TOAST_ACCORDION_FEW": "$1 Pemberitahuan: Klik di sini untuk melihat butiran",
  "TOAST_ACCORDION_MANY": "$1 Pemberitahuan: Klik di sini untuk melihat butiran",
  "TOAST_ACCORDION_OTHER": "$1 Pemberitahuan: Klik di sini untuk melihat butiran",
  "TOAST_ACCORDION_TWO": "$1 Pemberitahuan: Klik di sini untuk melihat butiran",
  "TOAST_ALT_ERROR": "Ralat",
  "TOAST_ALT_INFO": "Maklumat",
  "TOAST_ALT_SUCCESS": "Berjaya",
  "TOAST_ALT_WARN": "Amaran",
  "TOAST_DISMISS_BUTTON": "Tolak",
  "TOAST_TITLE_ALT": "Pemberitahuan",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Sejarah sembang, tekan kekunci anak panah untuk menavigasi.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "sejarah sembang",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Mesej adalah interaktif. Tekan kekunci shift tab 2 hingga 3 kali untuk bertukar ke sejarah sembang. Kemudian klik pada mesej untuk berinteraksi.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Satu atau lebih pautan dalam mesej. Tekan kekunci shift tab 2 hingga 3 kali untuk bertukar ke sejarah sembang. Kemudian klik pada mesej untuk berinteraksi.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Mesej mempunyai tindakan dicadangkan. Tekan shift tab 2 hingga 3 kali untuk memilih tindakan.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Mesej mempunyai tindakan dicadangkan. Tekan $1 untuk memilih tindakan.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Mesej gagal dihantar.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Mesej baharu tersedia. Tekan $1 menumpukan butang \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Lebih banyak mesej",
  "TRANSCRIPT_NEW_MESSAGES": "Mesej baharu",
  "TRANSCRIPT_TERMINATOR_TEXT": "Tamat sejarah sembang",
  "TYPING_INDICATOR_ALT": "Menunjukkan penunjuk menaip",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 sedang menaip.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 dan lain-lain sedang menaip.",
  "VIEW_CODE_BUTTON_TEXT": "Kod",
  "VOTE_COMPLETE_ALT": "Maklum balas direkodkan",
  "VOTE_COMPLETE_ALT.comment": "Ini adalah untuk pembaca skrin. Label butang dengan ikon ibu jari ke atas/ke bawah. Label digunakan apabila maklum balas direkodkan.",
  "VOTE_DISLIKE_ALT": "Tidak suka",
  "VOTE_LIKE_ALT": "Suka"
}